import { createFileRoute, redirect } from '@tanstack/react-router'
import { requireAuth } from '@/lib/middleware'

// Members Access is now a tab of the Roles & Permissions page. This stays as a
// redirect for bookmarks and old guide links.
export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/members'
)({
  beforeLoad: async () => {
    await requireAuth()
    throw redirect({
      to: '/organizations/settings/roles',
      search: { tab: 'members' },
      replace: true,
    })
  },
})
